// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4936d0ee] .el-dialog {\n  background-color: transparent;\n  box-shadow: 0 0 0px transparent;\n  -webkit-box-shadow: 0 0 0px transparent;\n}\n[data-v-4936d0ee] .el-dialog__headerbtn .el-dialog__close {\n  color: #ffffff;\n}\n[data-v-4936d0ee] .el-dialog .el-dialog__header {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
